import {
  Box,
  FormControlLabel,
  Grid,
  InputLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import useStyles from "./confirmationStyle";
const ServiceConfirmation = ({
  error,
  formData,
  setFormData,
  setError,
  isDisabled,
  setIsDoorToDoorAccept,
  setIsFullPackAccept,
  setAnyChangeFieldValue,
}: {
  error: any;
  formData: any;
  setFormData: any;
  setError: any;
  isDisabled: any;
  setIsDoorToDoorAccept: any;
  setIsFullPackAccept: any;
  setAnyChangeFieldValue: any;
}) => {
  const classes = useStyles();

  const handleServiceChange = (index: number, value: string) => {
    // Create a new array with updated service data
    const updatedServices = formData.services.map((service: any, idx: number) =>
      idx === index ? { ...service, status: value } : service
    );

    const doorTodoor: any = updatedServices?.find(
      (ele: any) => ele?.name === "Removal"
    );
    const fullPack: any = updatedServices?.find(
      (ele: any) => ele?.name === "Full Pack"
    );
    if (doorTodoor) {
      setIsDoorToDoorAccept(doorTodoor?.status !== "accept");
      setError({
        ...error,
        movingDate: null,
      });
    }
    if (fullPack) {
      setIsFullPackAccept(fullPack?.status !== "accept");
      setError({
        ...error,
        packingDate: null,
      });
    }

    // Update the state with the new array
    setFormData({
      ...formData,
      services: updatedServices,
      movingDate: {
        ...formData?.movingDate,
        status:
          doorTodoor &&
          doorTodoor?.status !== "accept" &&
          doorTodoor?.status !== null
            ? "awaiting"
            : formData?.movingDate?.status,
      },
      packingDate: {
        ...formData?.packingDate,
        status:
          fullPack && fullPack?.status !== "accept" && fullPack?.status !== null
            ? "awaiting"
            : formData?.packingDate?.status,
      },
    });

    setAnyChangeFieldValue(true);
    // Reset the error for the specific service's status
    // setError((prevError: any) => ({
    //   ...prevError,
    //   services: Array.isArray(prevError?.services)
    //     ? prevError.services.map((serviceError: any, idx: number) =>
    //         idx === index ? { ...serviceError, status: "" } : serviceError
    //       )
    //     : [], // Provide a fallback empty array if services is not an array
    // }));
  };

  const statusOptions = [
    { value: "accept", label: "Confirmed" },
    { value: "decline", label: "Not Taking" },
  ];

  return (
    <>
      <Grid container spacing={2} rowGap={0} rowSpacing={0}>
        <Grid
          item
          xs={12}
          md={12}
          sx={{ padding: "16px 6px 6px 6px !important" }}
        >
          <Typography sx={{ fontWeight: 600, color: "#0F906E" }}>
            Services
          </Typography>
        </Grid>
        {formData &&
          formData?.services?.map((field: any, idx: number) => (
            <>
              {/* <Grid
                item
                xs={12}
                sm={3}
                className={classes.labelBox}
                sx={{
                  marginTop: "0px !important",
                }}
              >
                <InputLabel
                  sx={{ color: "#333333", fontWeight: 600, fontSize: "18px" }}
                  shrink
                  htmlFor={field?.id}
                >
                  {field?.name}
                  <span style={{ color: "red", fontWeight: 500 }}>*</span>
                </InputLabel>
              </Grid> */}
              <Grid
                item
                xs={12}
                sm={12}
                sx={{
                  paddingLeft: "10px !important",
                  paddingTop: "6px !important",
                  display: "flex",
                  alignItems: "center",
                  borderTop: "2px solid #CFCFCF",
                  background: "#FFF",
                  minHeight: "100px !important",
                }}
              >
                <Box sx={{ display: "block" }}>
                  <InputLabel
                    sx={{ color: "#333333", fontWeight: 600, fontSize: "18px" }}
                    shrink
                    htmlFor={field?.id}
                  >
                    {field?.name}
                    <span style={{ color: "red", fontWeight: 500 }}>*</span>
                  </InputLabel>
                  <TextField
                    disabled={true}
                    sx={{
                      marginTop: "0px !important",
                      marginRight: "6px",
                      width: "120px",

                      // marginBottom: "8px !important",
                    }}
                    variant="outlined"
                    value={field?.cost}
                    InputProps={{
                      startAdornment: (
                        <span
                          style={{
                            marginRight: "1px",
                            paddingTop: "1px",
                            fontWeight: 600,
                            fontSize: "14px",
                          }}
                        >
                          £
                        </span>
                      ),
                      sx: {
                        height: "36px",
                        padding: "10px 4px",
                      },
                    }}
                    margin="normal"
                    fullWidth
                    error={
                      !!(error && error.services && error.services[idx]?.cost)
                    }
                    helperText={
                      error?.services && error.services[idx]?.cost
                        ? error.services[idx].cost
                        : ""
                    }
                  />
                </Box>
                <RadioGroup
                  row
                  value={field.status || ""}
                  onChange={(e) => handleServiceChange(idx, e.target.value)}
                  sx={{ display: "contents" }}
                >
                  {statusOptions.map((option) => (
                    <FormControlLabel
                      key={option.value}
                      sx={{
                        fontSize: "12px",
                        marginTop: "20px",
                        ".MuiTypography-root": {
                          fontSize: "12px",
                        },
                      }}
                      value={option.value}
                      disabled={isDisabled}
                      control={
                        <Radio
                          sx={{
                            color: error?.services?.[idx]?.status ? "red" : "",
                            transform: "scale(0.8)",
                            "& .MuiSvgIcon-root": { fontSize: 18 },
                          }}
                        />
                      }
                      label={option.label}
                    />
                  ))}
                </RadioGroup>
              </Grid>
            </>
          ))}
      </Grid>
    </>
  );
};

export default ServiceConfirmation;
